import ArticleForm from "@features/creation/articles/components/ArticleForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlusCircle } from "lucide-react";

export const Route = createFileRoute("/_app/creation/articles/create")({
  loader: requirePermission(PERMISSIONS.CREATION.ARTICLES.CREATE),
  staticData: {
    title: "Nouvel article",
    icon: PlusCircle,
    permission: PERMISSIONS.CREATION.ARTICLES.CREATE,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: CreateArticlePage,
});

function CreateArticlePage() {
  return (
    <div className="max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Nouvel article</h1>
        <p className="text-sm text-base-content/60">
          Créer un nouvel article dans le catalogue Création
        </p>
      </div>
      <ArticleForm />
    </div>
  );
}
